<template>
  <!-- Feature Section start -->
  <section
    id="feature"
    class="feature"
  >
    <div class="feature-decor">
      <div class="feature-circle1">
        <img
          src="../assets/images/feature2.png"
          alt=""
        >
      </div>
    </div>
    <div class="container">
      <div class="row">
        <!--
                  <div class="feature-phone">
                    <img :src='"../assets/images/222.png"' class="img-fluid" alt="">
                  </div>
                  -->
        <div class="offset-lg-4 col-lg-8">
          <div class="row">
            <div class="col-sm-12 mrgn-md-top">
              <h2 class="title">
                ez<span>Fix'd</span> Features
              </h2>
            </div>
            <div
              v-for="i in 2"
              :key="i"
              class="col-12 col-md-6"
            >
              <ul class="feature-style">
                <li
                  v-for="item in features.slice(((i - 1) * 2), i * 2)"
                  :key="item.id"
                >
                  <div class="feature-icon">
                    <img
                      :src="item.img"
                      alt="icon"
                    >
                  </div>
                  <div class="feature-subtitle">
                    <h3>{{ item.title }}</h3>
                  </div>
                  <div>
                    <p>
                      {{item.desc}}
                    </p>
                    <!-- <p>
                      {{ item.expand ? item.desc : item.desc.slice(0, 150) }}
                      <br>
                      <a
                        v-if="!item.expand && item.desc.length > 150"
                        class="text-primary text-lowercase cursor-pointer"
                        @click="item.expand = true"
                      >read more...</a>
                    </p> -->
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Feature Section End -->
</template>
<script>
export default {
  name: 'Feature',
  data() {
    return {
      features: [
        {
          id: 1,
          title: 'Simple Process',
          desc:
            'Choose a location, Create an account and start your car repair, enjoy our low prices and payment plans.',
          img: require('../assets/images/icon/1.png'),
          expand: false,
        },
        {
          id: 2,
          title: 'Car repairs just got a whole lot easier',
          desc:
            'Fix your vehicle as stress free as possible with our fully vetted & qualified mechanics. We follow up on each job our mechanics perform on several criteria to keep the standards high.',
          img: require('../assets/images/icon/3.png'),
          expand: false,
        },
        {
          id: 3,
          title: 'Need a payment plan?',
          desc:
            ' We got you covered, for repairs between $500 to $10,000, set the repayment method from monthly to weekly payments and the duration from 3 months to 24 months. You can pay it off anytime without any penalty.',
          img: require('../assets/images/icon/2.png'),
          expand: false,
        },
        {
          id: 4,
          title: 'Repair types',
          desc:
            'From body work, engine and transmission repair, tires and rims to AC repairs and cooling system repairs that require our the labour of our mechanics will be eligible.',
          img: require('../assets/images/icon/4.png'),
          expand: false,
        },
      ],
    }
  },
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/feature.vue